export var ParticleMaterialType;
(function (ParticleMaterialType) {
    ParticleMaterialType["shader"] = "shader";
    ParticleMaterialType["points"] = "points";
})(ParticleMaterialType || (ParticleMaterialType = {}));
export var EaseValuesType;
(function (EaseValuesType) {
    EaseValuesType["scale"] = "scale";
    EaseValuesType["alpha"] = "alpha";
})(EaseValuesType || (EaseValuesType = {}));
//# sourceMappingURL=index.js.map